module.exports = __webpack_public_path__ + "static/media/garmin-etrex-20x-4.1599cd55.jpg";